import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';
import { useLocation } from '@provider/navigation';
import { makeTanstackQuery } from '@provider/tanstack';
import { DAYS_TO_MS, MINUTES_TO_MS } from '@utils/constants';
import { getRevisionByIdRequest } from './request.get-by-id.js';

const getRevisionByIdQuery = makeTanstackQuery({
  defaultQueryConfig: {
    staleTime: 15 * MINUTES_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  },
  queryKey: input => ["course-revisions/get-by-id", input.revisionId],
  queryFn: input => getRevisionByIdRequest(input.revisionId),
  useQueryInput: (queryFactory, input) => queryFactory(input)
});
const useGetRevisionFromURLQuery = extraConfig => {
  const location = useLocation();
  const revisionIdFromURL = useRef(location.searchParams.get("revisionId")).current;
  return useQuery(getRevisionByIdQuery.useQueryConfig({
    revisionId: revisionIdFromURL,
    queryConfig: extraConfig
  }));
};

export { getRevisionByIdQuery, useGetRevisionFromURLQuery };
//# sourceMappingURL=query.get-from-url.js.map
